var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80.3 80.3",
    style: {
      enableBackground: "new 0 0 80.3 80.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EB6A5C;}\n\t.st1{fill:#552F2F;}\n\t.st2{fill:#55AB99;}\n\t.st3{fill:#2F4555;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#ED6B5A;}\n\t.st6{fill:#0C2C48;}\n\t.st7{fill:#F1CC4B;}\n\t.st8{clip-path:url(#SVGID_2_);}\n\t.st9{clip-path:url(#SVGID_2_);fill:#F6A09C;}\n\t.st10{fill:#50646F;}\n\t.st11{fill:#FCA886;}\n\t.st12{fill:#EDAB7E;}\n\t.st13{fill:#332319;}\n\t.st14{fill:#E07E45;}\n\t.st15{fill:#FF8F8F;}\n\t.st16{fill:#A6D1D9;}\n\t.st17{fill:#628185;}\n\t.st18{fill:#BABABA;}\n\t.st19{fill:#698391;}\n\t.st20{opacity:0.41;fill:#FFFFFF;}\n\t.st21{fill:#F6A09C;}\n\t.st22{fill:#FFF3C9;}\n\t.st23{fill:#2384AB;}\n\t.st24{fill:#BABFC5;}\n\t.st25{clip-path:url(#SVGID_4_);}\n\t.st26{fill:#6EB9E0;}\n\t.st27{fill:#F8A06D;}\n\t.st28{fill:#A3B9C4;}\n\t.st29{fill:#3B4A52;}\n\t.st30{clip-path:url(#SVGID_6_);}\n\t.st31{clip-path:url(#SVGID_8_);fill:#F6A09C;}\n\t.st32{opacity:0.21;fill:#FFFFFF;}\n\t.st33{clip-path:url(#SVGID_10_);fill:#F6A09C;}\n\t.st34{clip-path:url(#SVGID_12_);}\n\t.st35{fill:#FFD3B5;}\n\t.st36{fill:#BFD9E6;}\n\t.st37{fill:#798287;}\n\t.st38{fill:#A4A8AD;}\n\t.st39{fill:#FFD6BA;}\n\t.st40{fill:none;stroke:#0C2C48;stroke-width:1.4;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 40.2,
    cy: 40.2,
    r: 40.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.7,56.2c0,0.7-0.5,1.2-1.2,1.2H13.8c-0.7,0-1.2-0.5-1.2-1.2V17.4c0-0.7,0.5-1.2,1.2-1.2h52.8 c0.7,0,1.2,0.5,1.2,1.2V56.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8,
    y: 56.3,
    className: "st18",
    width: 20.7,
    height: 7
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 18.6,
    className: "st6",
    width: 49.3,
    height: 30.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12.6,48.1v8.1c0,0.7,0.5,1.2,1.2,1.2h52.8c0.7,0,1.2-0.5,1.2-1.2v-8.1H12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.7,68.1v-2.2c0-1.7-1.3-3-3-3h-25c-1.7,0-3,1.3-3,3v2.2H55.7z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 40.2,
    cy: 52.5,
    r: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "55.1,32.1 43.6,32.1 43.6,20.6 51.3,20.6 55.1,24.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "55.1,24.1 51.3,24.1 51.3,20.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.3,
    y: 23.2,
    className: "st2",
    width: 5.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.3,
    y: 25.9,
    className: "st2",
    width: 8.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.3,
    y: 28.6,
    className: "st2",
    width: 8.1,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "38.4,46.5 26.9,46.5 26.9,35.1 34.6,35.1 38.4,38.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "38.4,38.6 34.6,38.6 34.6,35.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 37.7,
    className: "st21",
    width: 5.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 40.4,
    className: "st21",
    width: 8.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 43,
    className: "st21",
    width: 8.1,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.3,33.9h-1v-9c0-1.4,1.1-2.5,2.5-2.5h9.1v1h-9.1c-0.8,0-1.5,0.7-1.5,1.5V33.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "39.6,25.2 42,22.9 39.6,20.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52.5,33.4h1v8.8c0,1.4-1.1,2.5-2.5,2.5h-9.1v-1H51c0.8,0,1.5-0.7,1.5-1.5V33.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "42.3,41.9 39.8,44.2 42.3,46.5  "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.22768faa085072aab48ee7c5fb7968c3.svg";
export { ForwardRef as ReactComponent };